<script>
  import { page, router } from "@inertiajs/svelte";

  import { afterUpdate } from "svelte";

  if (import.meta.env.DEV) {
    afterUpdate(() => {
      console.log("the component has mounted", $page);
    });
  }
</script>

<div class="container-fluid gx-5 pb-2">
  <div class="row">
    <div class="col-12 pt-2 mt-md-4">
      <slot />
    </div>
  </div>
</div>
